import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { get_token_from_local_storage } from "utils/getTokenFromStorage";

import {
  ActionPortal,
  Col,
  DefaultActionButtons,
  Form,
  FormGroup,
  Input,
  MaskedInput,
  Row,
  Step,
  Switch,
  Text,
  ValidatedInput,
} from "components";

import { inputsValidations } from "validations/inputsFieldsValidations";

import { StepPropTypes } from "../../constants/propTypes";
import TabContainer from "components/tabContainer";

export default function ContactInfo(props) {
  const { theme, onSubmit, onCancel, initialValues: defaultValues } = props;

  const {
    control,
    errors,
    formState,
    handleSubmit,
    register,
    watch,
    setValue,
    trigger,
  } = useForm({
    mode: "all",
    defaultValues,
  });

  const fieldsValidations = inputsValidations.BR;

  const { isValid } = formState;
  const useManagerInfo = watch("useManagerInfo");

  const managerName = watch("managerName");
  const managerEmail = watch("managerEmail");
  const managerPhone = watch("managerPhone");

  const [managerInfoSwitch, setManagerInfoSwitch] = useState(useManagerInfo);

  const changeManagerInfoSwitch = () => {
    const newManagerInfoSwitchState = !managerInfoSwitch;
    setManagerInfoSwitch(newManagerInfoSwitchState);
  };

  const syncFinanceManagerInfoWithManager = () => {
    const copyManagerToFinanceManager = {
      financeManagerName: managerName,
      financeManagerEmail: managerEmail,
      financeManagerPhone: managerPhone,
    };

    Object.entries(copyManagerToFinanceManager).forEach(([key, value]) =>
      setValue(key, value)
    );
    trigger();
  };
  const getEmailFromLoggedUserInToken = () => {
    const {
      userInfo: { email },
    } = get_token_from_local_storage();

    return email;
  };

  useEffect(() => {
    if (managerInfoSwitch) {
      syncFinanceManagerInfoWithManager();
    }
    // eslint-disable-next-line
  }, [managerName, managerPhone, managerEmail, managerInfoSwitch]);

  const submitForm = (e) => {
    e.preventDefault();

    handleSubmit(onSubmit)();
  };

  return (
    <Step {...props}>
      <TabContainer step={2} totalSteps={3}>
        <Form onKeyPress={(e) => e.key === "Enter" && submitForm(e)}>
          <Row form>
            <Col md="8">
              <h1
                style={{
                  fontWeight: 430,
                  fontSize: 24,
                  marginBottom: 24,
                }}
              >
                Gestor do Sistema
              </h1>
            </Col>
          </Row>
          <Row form>
            <Col md="8">
              <FormGroup>
                <p
                  for="managerName"
                  style={{
                    fontSize: 14,
                    marginBottom: 4,
                  }}
                >
                  Nome
                </p>
                <ValidatedInput
                  type="text"
                  name="managerName"
                  errors={errors}
                  placeholder="Nome do gestor"
                  invalid={!!errors.managerName}
                  innerRef={register({
                    required: fieldsValidations.required,
                    ...fieldsValidations.peopleName,
                  })}
                />
                <p
                  for="managerName"
                  style={{
                    fontSize: 12,
                    marginBottom: 4,
                    color: theme.newPalette.background.gray[100],
                  }}
                >
                  * Pessoa responsável pela utilização do sistema.
                </p>
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <p
                  for="managerPhone"
                  style={{
                    fontSize: 14,
                    marginBottom: 4,
                  }}
                >
                  Telefone Celular
                </p>
                <MaskedInput
                  control={control}
                  name="managerPhone"
                  rules={{
                    required: fieldsValidations.required,
                    ...fieldsValidations.phone,
                  }}
                  maxLength={17}
                  placeholder="Ex.: (11) 98123-5432"
                  errors={errors}
                  options={{
                    phone: true,
                    phoneRegionCode: "br",
                    prefix: "+55",
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row form>
            <Col md="12">
              <FormGroup>
                <p
                  for="managerEmail"
                  style={{
                    fontSize: 14,
                    marginBottom: 4,
                  }}
                >
                  E-mail
                </p>
                <ValidatedInput
                  type="text"
                  name="managerEmail"
                  placeholder="Ex.: nomeresponsavel@email.com"
                  invalid={!!errors.managerEmail}
                  disabled={true}
                  innerRef={register({
                    required: fieldsValidations.required,
                    ...fieldsValidations.email,
                  })}
                  defaultValue={getEmailFromLoggedUserInToken()}
                />
                <Text
                  fontSize={12}
                  color={"#E65845"}
                  style={{ marginTop: "8px" }}
                >
                  {errors.managerEmail?.message}
                </Text>
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col md="12">
              <h1
                style={{
                  fontWeight: 430,
                  fontSize: 24,
                  marginBottom: 24,
                  marginTop: 24,
                }}
              >
                Responsável pelo Financeiro
              </h1>
            </Col>
          </Row>
          <Row form>
            <Col md="12">
              <FormGroup>
                <Switch
                  inline
                  id="useManagerInfo"
                  name="useManagerInfo"
                  label="Quero usar os mesmos dados do Gestor"
                  innerRef={register}
                  checked={managerInfoSwitch}
                  onClick={changeManagerInfoSwitch}
                />
              </FormGroup>
            </Col>
          </Row>
          <>
            <Row form>
              <Col md="8">
                <FormGroup>
                  <p
                    for="financeManagerName"
                    style={{
                      fontSize: 14,
                      marginBottom: 4,
                    }}
                  >
                    Nome
                  </p>
                  <ValidatedInput
                    type="text"
                    name="financeManagerName"
                    errors={errors}
                    placeholder="Nome do gestor"
                    invalid={!!errors.financeManagerName}
                    innerRef={register({
                      required: fieldsValidations.required,
                      ...fieldsValidations.peopleName,
                    })}
                    disabled={managerInfoSwitch}
                  />
                  <p
                    for="managerName"
                    style={{
                      fontSize: 12,
                      marginBottom: 4,
                      color: theme.newPalette.background.gray[100],
                    }}
                  >
                    * Pessoa responsável pelo pagamento das faturas
                  </p>
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <p
                    for="financeManagerPhone"
                    style={{
                      fontSize: 14,
                      marginBottom: 4,
                    }}
                  >
                    Telefone Celular
                  </p>
                  <MaskedInput
                    control={control}
                    name="financeManagerPhone"
                    rules={{
                      required: fieldsValidations.required,
                      ...fieldsValidations.phone,
                    }}
                    maxLength={17}
                    errors={errors}
                    placeholder="Ex.: (11) 98123-5432"
                    options={{
                      phone: true,
                      phoneRegionCode: "br",
                      prefix: "+55",
                    }}
                    disabled={managerInfoSwitch}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col md="12">
                <FormGroup>
                  <p
                    for="financeManagerEmail"
                    style={{
                      fontSize: 14,
                      marginBottom: 4,
                    }}
                  >
                    E-mail
                  </p>
                  <Input
                    type="text"
                    name="financeManagerEmail"
                    id="financeManagerEmail"
                    placeholder="Ex.: nomeresponsavel@email.com"
                    invalid={!!errors.financeManagerEmail}
                    innerRef={register({
                      required: fieldsValidations.required,
                      ...fieldsValidations.email,
                    })}
                    disabled={managerInfoSwitch}
                  />
                  <Text
                    fontSize={12}
                    color={"#E65845"}
                    style={{ marginTop: "8px" }}
                  >
                    {errors.financeManagerEmail?.message}
                  </Text>
                </FormGroup>
              </Col>
            </Row>
          </>
          <ActionPortal>
            <DefaultActionButtons
              theme={theme}
              isValid={isValid}
              backButtonStyle={{
                iconPosition: "left",
                border: "none",
                customBackgroundColor: "transparent",
                customIconColor: theme.colors.text.label,
                customTextColor: theme.colors.text.label,
                title: "Passo Anterior",
              }}
              nextButtonStyle={{
                customBackgroundColor: theme.newPalette.background.purple,
                customIconColor: theme.colors.text.white,
                customTextColor: theme.colors.text.white,
                title: "Próximo Passo",
              }}
              onCancel={onCancel}
              onSubmit={() => handleSubmit(onSubmit)()}
            />
          </ActionPortal>
        </Form>
      </TabContainer>
    </Step>
  );
}

ContactInfo.propTypes = StepPropTypes;
